import { useRouter } from 'next/router';

/**
 * Custom hook to extract the hash fragment from the current URL path.
 * This hook uses the `useRouter` hook from Next.js to access the current URL path and extract the hash fragment.
 *
 * @returns {string} - Returns the hash fragment from the current URL path, prefixed with '#'. If no hash fragment is present, returns an empty string.
 *
 * @example
 * const hash = useNextHash();
 */
export function useNextHash(): string {
  // Destructure the asPath property from the useRouter hook
  const { asPath } = useRouter();

  // Split the asPath string by '#' and get the second part (hash fragment)
  const hash: string | undefined = asPath.split('#')?.[1];

  // Return the hash fragment prefixed with '#' if it exists, otherwise return an empty string
  return !!hash ? `#${hash}` : '';
}
